import { useState } from 'react';
import { useRequest } from 'src/hooks/useResource';

type FFProjectName = 'fraud-platform' | 'enterprise-partner-api';
export type AuthType = 'unauthenticated' | 'authenticated';

type FeatureFlagResponse = boolean;

interface FFParams {
  featureFlagKey: FeatureFlagKey;
  projectName?: FFProjectName;
  authType?: AuthType;
  filter?: string;
}

export enum FeatureFlagKey {
  bankLinking = 'bank-linking-dup-experience',
  movedTerms = 'peog-704-move-terms'
}

const FEATURE_FLAG_ROUTES: Record<AuthType, string> = {
  unauthenticated: `unauthenticated/feature-flag`,
  authenticated: `feature-flag`
};

export function useFeatureFlag({
  projectName = 'fraud-platform',
  authType = 'unauthenticated',
  featureFlagKey,
  filter
}: FFParams) {
  const [data, setData] = useState<FeatureFlagResponse>();

  const { makeRequest } = useRequest('ff');

  const getFeatureFlag = async () => {
    const path = `/${FEATURE_FLAG_ROUTES[authType]}/${projectName}?featureFlagKey=${featureFlagKey}${filter ? `&filter=${filter}` : ''}`;

    const res = await makeRequest<FeatureFlagResponse>({ path });

    setData(res);
  };

  return { getFeatureFlag, data };
}
